// extracted by mini-css-extract-plugin
export default {"blender_bottle_item":"JE","blender_bottle_img":"KE","blender_bottle_info":"LE","blender_bottle_title":"ME","blender_bottle_bold":"NE","blender_bottle_usual":"OE","blender_bottle_item_mob":"PE","addbutton":"QE","blender_bottle_title_mob":"RE","blender_bottle_bold_mob":"SE","blender_bottle_usual_mob":"TE","bolder":"UE","bottom_margin_4":"VE","bottom_margin_16":"WE"};
    if(module.hot) {
      // 1715188236316
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  